/**
 * The two status values a single-search URL ever carries. NOT the wire/API contract enum
 * (see `SearchQueryStatus` in `types/search/searchQuery.ts`, which models the full set
 * `Done | Live | Online | Passed | Sold | Upcoming` accepted by search-party).
 */
export enum SearchUrlStatus {
    Archive = 'archive',
    Online = 'online',
}
